export enum ResidentialStatusEnum {
  alient = 'A',
  citizen = 'C',
  pr = 'P',
  unknown = 'U',
  not_applicable = 'N',
}
